module.exports = __webpack_public_path__ + "static/media/rike-first-text.5c0fe483.png";